import React from 'react';
import { SmartphoneIcon, FolderCheckIcon, SendIcon, TagIcon, TrendingUpIcon } from 'lucide-react';
import { Reveal, Eyebrow } from './Section';
const benefits = [{
  icon: SmartphoneIcon,
  title: 'Creá tus primeros videos UGC',
  text: 'Con el celular y productos que ya tenés en casa, aunque todavía no tengas experiencia.'
}, {
  icon: FolderCheckIcon,
  title: 'Construí un portfolio profesional',
  text: 'Con muestras estratégicas para empezar a presentarte ante marcas con seguridad.'
}, {
  icon: SendIcon,
  title: 'Contactá +80 marcas',
  text: 'Aprendé a encontrar, contactar y hacer seguimiento con mensajes claros y profesionales.'
}, {
  icon: TagIcon,
  title: 'Definí servicios y precios',
  text: 'Creá paquetes y poné precios en dólares sin cobrar al azar ni regalar tu trabajo.'
}, {
  icon: TrendingUpIcon,
  title: 'Generá una nueva fuente de ingresos',
  text: 'Transformá tu habilidad para crear contenido en tu camino hacia tus primeros USD 1.000.'
}];
export function Benefits() {
  return <section className="w-full bg-cream py-16 sm:py-24" data-id="element-21" data-mp="6sjioe7wk8t9">
      <div className="mx-auto max-w-6xl px-5 sm:px-6" data-id="element-22" data-mp="6u4bnzekjjp0">
        <Reveal className="mx-auto max-w-2xl text-center" data-id="element-23" data-mp="3oz7k9u3qudu6">
          <Eyebrow data-id="element-24" data-mp="3p0r2hq8ymyyl">Con este producto vas a poder</Eyebrow>
          <h2 className="mt-4 font-display text-3xl font-semibold leading-tight text-plum sm:text-4xl" data-id="element-25" data-mp="3tyadmhad2vmb">
            Todo lo que necesitás para empezar, en un solo lugar
          </h2>
        </Reveal>

        <div className="mt-12 grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-3" data-id="element-26" data-mp="qfh5ik0cqyzj">
          {benefits.map((b, i) => <Reveal key={b.title} delay={i * 0.06} data-id="element-27" data-mp="bps02cl888tg" data-mpi={i}>
              <div className="group h-full rounded-2xl border border-sand bg-white p-7 shadow-card transition-all duration-300 hover:-translate-y-1.5 hover:border-coral/40" data-id="element-28" data-mp="gq79wu6auy6o">
                <span className="flex h-12 w-12 items-center justify-center rounded-2xl bg-coral text-white transition-transform duration-300 group-hover:scale-105" data-id="element-29" data-mp="19705ehz2xwxc">
                  <b.icon className="h-6 w-6" data-id="element-30" data-mp="1j2h2i7qf5p02" />
                </span>
                <h3 className="mt-5 font-display text-xl font-semibold text-plum" data-id="element-31" data-mp="1e574w4svm715">
                  {b.title}
                </h3>
                <p className="mt-2 text-sm leading-relaxed text-ink/70" data-id="element-32" data-mp="1975q3w2hgtvh">{b.text}</p>
              </div>
            </Reveal>)}
        </div>
      </div>
    </section>;
}